import {
  CHANGE_EDITERMODE,
  CHANGE_SWMODE,
  CHANGE_REGMODE,
  CHANGE_INPREDICT,
  CHANGE_INEXEWAITING,
  FIN_LRN,
  CHANGE_LOCINFO,
  CHANGE_DIST,
  CHANGE_POSTAB,
  CHANGE_PRETAB,
  CHANGE_RSLTTAB,
  CHANGE_LAYEROPA,
  SET_USERLICENSE,
  SET_MODULETABLE,
  CHANGE_ISSTART,
  CHANGE_ISBUSYS,
  CHANGE_ISBUSYC,
  CHANGE_IMPWS,
  CHANGE_DATADWONLOAD,
  SET_GMURL,
  CHANGE_WATINGTIME,
} from "./actions";

const initData = {
  //エディタを開かない場合は1（断面ライン・モデル領域・ユーザー定義ボーリング作成中）
  editerMode: 0,
  //サブウィンドウを開いている場合1
  swMode: 0,
  //登録モード（0=新規/1=編集）
  regMode: 0,
  //学習・予測実行中の場合true
  inPredict: false,
  //実行待ち時間
  waitingTime: 0,
  //学習実行済みの場合true
  finLrn: false,
  //実行待ちの場合true
  inExeWating: false,
  //地点情報のクリック位置
  lon: 0,
  lat: 0,
  //距離計測の距離
  dist: 0,
  //平面・断面タブの選択値（pl=平面/cs=断面）
  posTab: "pl",
  preTab: "pl",
  rsltTab: "pl",
  //予測表示（平面）のレイヤー不透明度
  layerOpa: 80,
  userLicense: 2,
  moduleTable: [],
  isStart: false,
  isBusy: false,
  impWS: false,
  dataDownload: 0,
};

export function appReducer(state = initData, action) {
  switch (action.type) {
    case CHANGE_EDITERMODE:
      return changeEditerModeReduce(state, action);
    case CHANGE_SWMODE:
      return changeSwModeReduce(state, action);
    case CHANGE_REGMODE:
      return changeRegModeReduce(state, action);
    case CHANGE_INPREDICT:
      return changeInPredictReduce(state, action);
    case CHANGE_INEXEWAITING:
      return changeInExeWaitingReduce(state, action);
    case CHANGE_WATINGTIME:
      return changeWaitingTimeReduce(state, action);
    case FIN_LRN:
      return finLrnReduce(state, action);
    case CHANGE_LOCINFO:
      return changeLocInfoReduce(state, action);
    case CHANGE_DIST:
      return changeDistReduce(state, action);
    case CHANGE_POSTAB:
      return changePosTabReduce(state, action);
    case CHANGE_PRETAB:
      return changePreTabReduce(state, action);
    case CHANGE_RSLTTAB:
      return changeRsltTabReduce(state, action);
    case CHANGE_LAYEROPA:
      return changeLayerOpaReduce(state, action);
    case SET_USERLICENSE:
      return setUserLicenseReduce(state, action);
    case SET_MODULETABLE:
      return setModuleTableReduce(state, action);
    case CHANGE_ISSTART:
      return changeIsStartReduce(state, action);
    case CHANGE_ISBUSYS:
      return changeIsBusySReduce(state, action);
    case CHANGE_ISBUSYC:
      return changeIsBusyCReduce(state, action);
    case CHANGE_IMPWS:
      return changeImpWSReduce(state, action);
    case CHANGE_DATADWONLOAD:
      return changeDataDownloadReduce(state, action);
    case SET_GMURL:
      return setGMUrlReduce(state, action);
    default:
      return state;
  }
}

export function changeEditerModeReduce(state, action) {
  return {
    ...state,
    editerMode: action.mode,
  };
}

export function changeSwModeReduce(state, action) {
  return {
    ...state,
    swMode: action.mode,
  };
}

export function changeRegModeReduce(state, action) {
  return {
    ...state,
    regMode: action.mode,
  };
}

export function changeInPredictReduce(state, action) {
  return {
    ...state,
    inPredict: action.value,
  };
}

export function changeInExeWaitingReduce(state, action) {
  return {
    ...state,
    inExeWating: action.value,
  };
}

export function changeWaitingTimeReduce(state, action) {
  return {
    ...state,
    waitingTime: action.value,
  };
}

export function finLrnReduce(state, action) {
  return {
    ...state,
    finLrn: action.isFin,
  };
}

export function changeLocInfoReduce(state, action) {
  return {
    ...state,
    lon: action.coords[0],
    lat: action.coords[1],
  };
}

export function changeDistReduce(state, action) {
  return {
    ...state,
    dist: action.dist,
  };
}

export function changeBColorReduce(state, action) {
  return {
    ...state,
    bColor: action.bColor,
  };
}

export function changePosTabReduce(state, action) {
  return {
    ...state,
    posTab: action.value,
  };
}

export function changePreTabReduce(state, action) {
  return {
    ...state,
    preTab: action.value,
  };
}

export function changeRsltTabReduce(state, action) {
  return {
    ...state,
    rsltTab: action.value,
  };
}

export function changeLayerOpaReduce(state, action) {
  return {
    ...state,
    layerOpa: action.value,
  };
}

export function setUserLicenseReduce(state, action) {
  return {
    ...state,
    userLicense: action.value,
  };
}

export function setModuleTableReduce(state, action) {
  return {
    ...state,
    moduleTable: action.value,
  };
}

export function changeIsStartReduce(state, action) {
  return {
    ...state,
    isStart: action.value,
  };
}

export function changeIsBusySReduce(state, action) {
  return {
    ...state,
    isBusyS: action.value,
  };
}

export function changeIsBusyCReduce(state, action) {
  return {
    ...state,
    isBusyC: action.value,
  };
}

export function changeImpWSReduce(state, action) {
  return {
    ...state,
    impWS: action.value,
  };
}

export function changeDataDownloadReduce(state, action) {
  return {
    ...state,
    dataDownload: action.value,
  };
}

export function setGMUrlReduce(state, action) {
  return {
    ...state,
    gmUrl: action.value,
  };
}
